import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtMetaWhatsAppConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/WhatsApp/ExtMetaWhatsAppConfigModel';

export enum MetaWhatsAppConfigActionTypes {
    ADD_META_WA_CONFIG = '[MetaWhatsAppConfig] Create MetaWhatsAppConfig',
    ADD_META_WA_CONFIGS = '[MetaWhatsAppConfig] Add MetaWhatsAppConfigs',
    UPSERT_META_WA_CONFIG = '[MetaWhatsAppConfig] Upsert MetaWhatsAppConfig',
    UPSERT_META_WA_CONFIGS = '[MetaWhatsAppConfig] Upsert MetaWhatsAppConfigs',
    UPDATE_META_WA_CONFIG = '[MetaWhatsAppConfig] Update MetaWhatsAppConfig',
    UPDATE_META_WA_CONFIGS = '[MetaWhatsAppConfig] Update MetaWhatsAppConfigs',
    DELETE_META_WA_CONFIG = '[MetaWhatsAppConfig] Delete MetaWhatsAppConfig',
    DELETE_META_WA_CONFIGS = '[MetaWhatsAppConfig] Delete MetaWhatsAppConfigs',
    DELETE_ALL_META_WA_CONFIGS = '[MetaWhatsAppConfig] Delete All MetaWhatsAppConfigs',
    DELETE_ALL = '[MetaWhatsAppConfig] Delete All',

    UPDATE_SELECTED_ID = '[MetaWhatsAppConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_user_id: number) {}
}

export class AddOne implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.ADD_META_WA_CONFIG;
    constructor(public config: ExtMetaWhatsAppConfigModel) {}
}

export class AddMany implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.ADD_META_WA_CONFIGS;
    constructor(public configs: Array<ExtMetaWhatsAppConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.UPSERT_META_WA_CONFIG;

    constructor(public config: ExtMetaWhatsAppConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.UPSERT_META_WA_CONFIGS;
    constructor(public configs: Array<ExtMetaWhatsAppConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.UPDATE_META_WA_CONFIG;
    constructor(public config: Update<ExtMetaWhatsAppConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.UPDATE_META_WA_CONFIGS;
    constructor(public configs: Array<Update<ExtMetaWhatsAppConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.DELETE_META_WA_CONFIG;
    constructor(public user_id: number) {}
}

export class DeleteMany implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.DELETE_META_WA_CONFIGS;
    constructor(public user_ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.DELETE_ALL_META_WA_CONFIGS;
    constructor(public user_ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = MetaWhatsAppConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type MetaWhatsAppConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
